<script setup>
  import { ref } from 'vue'
  import BaseOffCanvas from '../common/BaseOffCanvas.vue'
  import BcsDynamicText from '../BcsDynamicText.vue'
  import certIcon from '@/assets/images/bcs-certification-modal.svg'

  const emit = defineEmits(['viewProgressDetails'])

  const offcanvasRef = ref(null)

  async function open() {
    await offcanvasRef.value?.show()
  }

  async function close() {
    await offcanvasRef.value?.hide()
  }

  function goToProgress() {
    emit('viewProgressDetails')
    close()
  }

  defineExpose({ open, close })
</script>

<template>
  <BaseOffCanvas
    ref="offcanvasRef"
    canvas-id="bcs-certification-panel"
    canvas-position="end">

    <template #title>
      <span class="bcp-title">What is the BCS Compliance Operator Certificate?</span>
    </template>

    <template #default>
      <div class="text-center mt-3 mb-4">
        <img :src="certIcon" alt="" class="bcp-icon" />
      </div>
      <BcsDynamicText text="bcsComplianceCertificateDefinition" />
      <div class="d-flex justify-content-center mt-4">
        <button class="btn btn-primary" @click="goToProgress">
          View My Progress Details
        </button>
      </div>
    </template>
  </BaseOffCanvas>
</template>

<style scoped>
  .bcp-icon {
    max-width: 280px;
  }

  .bcp-title {
    font-size: 1.375rem;   /* 22px */
    font-weight: 700;
    line-height: 125%;
    letter-spacing: -0.44px;
    color: var(--bs-body-color);
  }
</style>
